import React from 'react';
import { NotFound } from '@picsio/icons';

import styles from './styles.module.scss';

const PlaceholderEmpty = ({ icon, entity, isSearch = false }) => {
  if (isSearch) {
    return (
      <div className={styles.placeholderEmpty}>
        <NotFound />
        <h3>No matches found</h3>
        <p>There are no items matching your query in the current list.</p>
      </div>
    );
  }
  return (
    <div className={styles.placeholderEmpty}>
      {icon}
      <h3>No {entity} detected</h3>
      <p>This section is empty because the analysis returned no {entity}. Other insights may still be available.</p>
    </div>
  );
};
export default PlaceholderEmpty;
